import React from 'react';
import { MODULES } from '../constants';
import { ModuleContent } from '../types';
import { Lock, CheckCircle, Circle, ArrowRight } from 'lucide-react';

interface LearnProps {
  completedModules: string[];
  onSelectModule: (m: ModuleContent) => void;
}

export const Learn: React.FC<LearnProps> = ({ completedModules, onSelectModule }) => {
  return (
    <div className="max-w-5xl mx-auto p-6 md:p-12">
      <h2 className="text-3xl font-bold mb-8 text-cyber-dark border-b pb-4">Learning Modules</h2>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {MODULES.map((module) => {
          const isCompleted = completedModules.includes(module.id);
          
          return (
            <div 
              key={module.id}
              onClick={() => onSelectModule(module)}
              className={`bg-white rounded-xl shadow-md p-6 cursor-pointer transform transition-all hover:scale-105 hover:shadow-xl border-l-4 ${isCompleted ? 'border-green-500' : 'border-cyber-accent'}`}
            >
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-slate-800">{module.title}</h3>
                {isCompleted ? <CheckCircle className="text-green-500" /> : <Circle className="text-slate-300" />}
              </div>
              
              <p className="text-slate-500 text-sm mb-6 line-clamp-2">{module.definition}</p>
              
              <div className="flex items-center text-cyber-accent font-bold text-sm">
                {isCompleted ? 'Review' : 'Start Learning'} <ArrowRight size={16} className="ml-1" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
